import React, { useCallback, useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'

import { ELARA_PANEL_WIDTH, ElaraPanelContent } from '@/components/elara/ElaraPanel'
import { useElaraPanel } from '@/providers/elara/ElaraPanelContext'
import { useElaraRealtimeLicenseEnabled } from '@/providers/elara/hooks/useElaraRealtimeLicenseEnabled'

import Topbar from './Topbar'

type ContextType = {
  topbarContentContainer: HTMLDivElement | null
}

export type DiagnosticLayoutProps = {}

export default function DiagnosticLayout(props: DiagnosticLayoutProps) {
  const [topbarContentContainer, setTopbarContentContainer] = useState<HTMLDivElement | null>(null)

  const handleSetTopbarContentContainerRef = useCallback((el: HTMLDivElement | null) => {
    setTopbarContentContainer(el)
  }, [])

  // The ELARA side panel is a layout sibling (same as MainLayout) — without this the FAB
  // toggled a panel that nothing rendered on consultation pages.
  const elaraPanel = useElaraPanel()
  const hasElaraLicense = useElaraRealtimeLicenseEnabled()
  const isPanelOpen = (elaraPanel?.isPanelOpen ?? false) && hasElaraLicense

  return (
    <Stack direction="row" sx={{ height: '100vh', backgroundColor: (theme) => theme.palette.background.default }}>
      <Stack sx={{ flex: 1, minWidth: 0, height: '100%' }}>
        <Topbar
          setContentContainerRef={handleSetTopbarContentContainerRef}
          rightPanelWidth={isPanelOpen ? ELARA_PANEL_WIDTH : 0}
        />
        <Toolbar />
        <Outlet context={{ topbarContentContainer }} />
      </Stack>
      {isPanelOpen && <ElaraPanelContent />}
    </Stack>
  )
}

export function useDiagnosticLayout() {
  return useOutletContext<ContextType>()
}
